import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-row mt-6" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "w-2/12 text-medium mt-4" }, " Status ", -1)
const _hoisted_3 = { class: "w-10/12 flex flex-row flex-wrap" }
const _hoisted_4 = { class: "flex flex-row" }
const _hoisted_5 = { class: "flex flex-row items-center mr-8 mt-4 cursor-pointer" }
const _hoisted_6 = ["value"]
const _hoisted_7 = {
  class: "ml-2 cursor-pointer",
  for: `status-filter-draft`
}
const _hoisted_8 = { class: "flex flex-row items-center mr-8 mt-4 cursor-pointer" }
const _hoisted_9 = ["value"]
const _hoisted_10 = {
  class: "ml-2 cursor-pointer",
  for: `status-filter-awaiting`
}
const _hoisted_11 = { class: "flex flex-row items-center mr-8 mt-4 cursor-pointer" }
const _hoisted_12 = ["value"]
const _hoisted_13 = {
  class: "ml-2 cursor-pointer",
  for: `status-filter-accepted`
}
const _hoisted_14 = { class: "flex flex-row items-center mr-8 mt-4 cursor-pointer" }
const _hoisted_15 = ["value"]
const _hoisted_16 = {
  class: "ml-2 cursor-pointer",
  for: `status-filter-products-used-not-offered`
}
const _hoisted_17 = { class: "flex flex-row items-center mr-8 mt-4 cursor-pointer" }
const _hoisted_18 = ["value"]
const _hoisted_19 = {
  class: "ml-2 cursor-pointer",
  for: `status-filter-rejected`
}
const _hoisted_20 = { class: "flex flex-row items-center mr-8 mt-4 cursor-pointer" }
const _hoisted_21 = ["value"]
const _hoisted_22 = {
  class: "ml-2 cursor-pointer",
  for: `status-filter-archived`
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    modelValue: _ctx.show,
    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.show) = $event)),
    onConfirmClick: _ctx.handleFiltersConfirmClick
  }, {
    title: _withCtx(() => [
      _createTextVNode("Proposals list filters")
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                class: "cursor-pointer",
                id: `status-filter-draft`,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localFilters.status) = $event)),
                value: _ctx.draftStatus
              }, null, 8, _hoisted_6), [
                [_vModelCheckbox, _ctx.localFilters.status]
              ]),
              _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('proposal.status.draft')), 1)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                class: "cursor-pointer",
                id: `status-filter-awaiting`,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.localFilters.status) = $event)),
                value: _ctx.awaitingStatus
              }, null, 8, _hoisted_9), [
                [_vModelCheckbox, _ctx.localFilters.status]
              ]),
              _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('proposal.status.awaiting')), 1)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                class: "cursor-pointer",
                id: `status-filter-accepted`,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.localFilters.status) = $event)),
                value: _ctx.acceptedStatus
              }, null, 8, _hoisted_12), [
                [_vModelCheckbox, _ctx.localFilters.status]
              ]),
              _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.$t('proposal.status.accepted')), 1)
            ]),
            _createElementVNode("div", _hoisted_14, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                class: "cursor-pointer",
                id: `status-filter-products-used-not-offered`,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.localFilters.status) = $event)),
                value: _ctx.productsUsedNotOfferedStatus
              }, null, 8, _hoisted_15), [
                [_vModelCheckbox, _ctx.localFilters.status]
              ]),
              _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.$t('proposal.status.products_used_not_offered')), 1)
            ]),
            _createElementVNode("div", _hoisted_17, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                class: "cursor-pointer",
                id: `status-filter-rejected`,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.localFilters.status) = $event)),
                value: _ctx.rejectedStatus
              }, null, 8, _hoisted_18), [
                [_vModelCheckbox, _ctx.localFilters.status]
              ]),
              _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.$t('proposal.status.rejected')), 1)
            ]),
            _createElementVNode("div", _hoisted_20, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                class: "cursor-pointer",
                id: `status-filter-archived`,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.localFilters.status) = $event)),
                value: _ctx.archivedStatus
              }, null, 8, _hoisted_21), [
                [_vModelCheckbox, _ctx.localFilters.status]
              ]),
              _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.$t('proposal.status.archived')), 1)
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "onConfirmClick"]))
}